module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving11-b6e4194ae0fcd87498c113f92bf3d4d6.jpg";